import * as Yup from "yup";

export const roleExteraDiscountValidation = Yup.object().shape({
  percent: Yup.number()
    .typeError("درصد تخفیف باید عدد باشد")
    .min(0, "درصد تخفیف باید بین ۰ تا ۱۰۰ باشد")
    .max(100, "درصد تخفیف باید بین ۰ تا ۱۰۰ باشد")
    .required("وارد کردن درصد تخفیف الزامی است")
});

export const linkCodeExteraDiscountValidation = Yup.object().shape({
  percent: Yup.number()
    .typeError("درصد تخفیف باید عدد باشد")
    .min(0, "درصد تخفیف باید بین ۰ تا ۱۰۰ باشد")
    .max(100, "درصد تخفیف باید بین ۰ تا ۱۰۰ باشد")
    .required("وارد کردن درصد تخفیف الزامی است"),
    linkCode: Yup.string()
    .required("وارد کردن کد لینک الزامی است"),
});
